import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 14 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.09.273H1.91C1.402.273.917.47.56.823c-.358.353-.56.83-.56 1.328V9.85c0 .498.202.975.56 1.327.358.353.843.55 1.35.551h10.18c.507 0 .992-.198 1.35-.55.358-.353.56-.83.56-1.328V2.15c0-.498-.202-.975-.56-1.327a1.927 1.927 0 0 0-1.35-.551ZM1.91 1.525h10.18c.106.002.209.031.3.083L7 5.602 1.61 1.608a.627.627 0 0 1 .3-.083ZM12.726 9.85a.622.622 0 0 1-.186.442.642.642 0 0 1-.45.184H1.909a.642.642 0 0 1-.45-.184.622.622 0 0 1-.186-.442V2.926L7 7.17l5.727-4.244v6.923Z",
      fill: "#000"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "email"}) } }